// src/pages/delivery/DeliveryDashboardPage.jsx
import React from "react";
import DeliveryDashboard from "../../components/delivery/DeliveryDashboard";

const DeliveryDashboardPage = () => {
  return <DeliveryDashboard />;
};

export default DeliveryDashboardPage;
